(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-leia-sound-status.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-leia-sound-status.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useMemo = _React.useMemo;
const useLeiaSoundStatus = _ref => {
  let ticketInfo = _ref.ticketInfo;
  const hasSound = ticketInfo.hasSound,
    hasSoundDefaultOn = ticketInfo.hasSoundDefaultOn,
    type = ticketInfo.type;
  const logger = svs.ticketgames.ticketUtility.logger;
  const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.useSoundEnabled({
      ticketInfo
    }),
    soundEnabled = _svs$ticketgames$tick.soundEnabled,
    usersSavedSoundStatus = _svs$ticketgames$tick.usersSavedSoundStatus,
    setUsersSavedSoundStatus = _svs$ticketgames$tick.setUsersSavedSoundStatus;
  const _useState = useState(soundEnabled),
    _useState2 = _slicedToArray(_useState, 2),
    soundStatus = _useState2[0],
    setSoundStatus = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    receivedFirstSoundStatus = _useState4[0],
    setReceivedFirstSoundStatus = _useState4[1];
  const handleGameComplete = () => {
    if (hasSound) {
      logger.info("SoundStatus: ".concat(soundStatus, ", DefaultSoundStatus: ").concat(hasSoundDefaultOn, ", UsersSavedSoundStatus: ").concat(usersSavedSoundStatus, ", GameCode: ").concat(type));
    }
  };
  const handleSoundStatus = e => {
    logger.info("sound changed to ".concat(e.detail, " for ").concat(type));
    if (receivedFirstSoundStatus) {
      setUsersSavedSoundStatus(e.detail);
    }
    setSoundStatus(e.detail);
    setReceivedFirstSoundStatus(true);
  };
  const notifySoundStatus = soundStatus => {
    var _gameloaderHelper$ins, _gameloaderHelper$ins2;
    (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins = _gameloaderHelper$ins.notifierProxy) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins2 = _gameloaderHelper$ins.notifySoundStatus) === null || _gameloaderHelper$ins2 === void 0 || _gameloaderHelper$ins2.call(_gameloaderHelper$ins, soundStatus);
  };
  const soundEvents = useMemo(() => [{
    eventName: 'HAS_CLAIMED',
    handler: handleGameComplete
  }, {
    eventName: 'SOUND_STATUS',
    handler: handleSoundStatus
  }], [handleGameComplete, handleSoundStatus]);
  useEffect(() => {
    if (!receivedFirstSoundStatus) {
      if (soundEnabled !== soundStatus) {
        logger.warn("Sound status is ".concat(soundStatus, " for ").concat(type, ", but expected ").concat(soundEnabled, ". hasSound: ").concat(hasSound, ", hasSoundDefaultOn: ").concat(hasSoundDefaultOn, ", usersSavedSoundStatus: ").concat(usersSavedSoundStatus));
      }
    }
  }, [soundStatus, receivedFirstSoundStatus]);
  useEffect(() => {
    soundEvents.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      soundEvents.forEach(evt => removeEventListener(evt.eventName, evt.handler));
    };
  }, [soundStatus, receivedFirstSoundStatus]);
  return {
    soundStatus,
    notifySoundStatus,
    soundEvents
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useLeiaSoundStatus', useLeiaSoundStatus);

 })(window);